const countries = [
  { name: 'United States', abbreviation: 'USA' },
  { name: 'Canada', abbreviation: 'CAN' },
  { name: 'Mexico', abbreviation: 'MEX' },
];

export default countries;
